<rt-dialog-body variant="white">
  <div class="content-container">
    <div class="left">
      <rt-heading class="heading" variant="large-x-dialog-header bold dark">
        {{ 'tlc.positions.import_skills_flow.intro.heading' | translate }}
      </rt-heading>

      <rt-feature-discovery-stepper [steps]="steps" />
    </div>
    <div class="right">
      <img
        class="intro-illustration"
        ngSrc="assets/images/tellent-skills/import-skills.svg"
        alt=""
        [width]="323"
        [height]="371"
      />
    </div>
  </div>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true" innerPadding="small">
  <div class="optional">
    <rt-checkbox [formControl]="dontShowAgainControl">
      {{ 'tlc.positions.import_skills_flow.intro.dont_show_again' | translate }}
    </rt-checkbox>
  </div>
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" (click)="continue()">
    <span>{{ 'tlc.common.continue' | translate }}</span>
    <rt-icon name="keyboard-arrow-right" />
  </rt-button>
</rt-dialog-footer>
